const topPerformersDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();
        const { players, gamePk: topPerformersGamePk } = state.topPerformers;
        const { gamePk } = state.gumbo;
        const { locale } = state.config;
        if (players?.length > 0 && topPerformersGamePk === gamePk) {
            /* if we already have topPerformers data for this game
            * from the boxscore source, bypass the spotlightGame stitch
            */
            return;
        }

        return Promise.allSettled([
            componentDataEngine.fetchAndStore('spotlightGame', { gamePk, locale })
        ]);
    };
};

export default topPerformersDataRequestAction;
